export default "__VITE_ASSET__7ed01809__"